// React Index.tsx - Entry point for TestWerk.ai Dashboard
import React from 'react';
import ReactDOM from 'react-dom/client';
import UpdatedAppTsxModularVersion from './App';

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create root and render app
const root = ReactDOM.createRoot(rootElement);

root.render(
  //<React.StrictMode>
    <UpdatedAppTsxModularVersion />
  //</React.StrictMode>
);